import { TextField, Button } from "@mui/material";
import { useState } from "react";
import { useUser } from './UserProvider';

export function SchedulePost() {
  const {userInfo} = useUser();
  const [text, setText] = useState("");
    // const [scheduledAt, setScheduledAt] = useState(Date.now() + 1000 * 60 * 60 * 24);

  
  function schedulePost() {   

    let url = 'https://www.linkedin.com/voyager/api/graphql?includeWebMetadata=true&variables=(profileUrn:urn%3Ali%3Afsd_profile%3AACoAADbRmpABnBIvHyef0gDqIMQfsjTHl3UVCNA)&queryId=voyagerIdentityDashProfiles.48a9b24f61abc4d83c7fdbcd5408e871'

    post(url, "GET", null);

    // const tomorrow = Date.now() + 1000 * 60 * 60 * 24;
    // const rounded = Math.round(tomorrow / (10 * 60 * 1000)) * (10 * 60 * 1000);

    // let reqBody = {"variables":{"post":{"allowedCommentersScope":"ALL","intendedShareLifeCycleState":"SCHEDULED","origin":"FEED","visibilityDataUnion":{"visibilityType":"ANYONE"},"commentary":{"text":text,"attributesV2":[]},"scheduledAt":rounded}},"queryId":"voyagerContentcreationDashShares.2e462fe06c2124f6ec35370ea350e18a","includeWebMetadata":true}

    // post("https://www.linkedin.com/voyager/api/graphql?action=execute&queryId=voyagerContentcreationDashShares.2e462fe06c2124f6ec35370ea350e18a", "POST", reqBody);
  }

  function getMyRecentPosts() {
    if (!userInfo) {
      console.log("No user info, unable to fetch recent posts");
      return;
    }

    const url = `https://www.linkedin.com/voyager/api/graphql?includeWebMetadata=true&variables=(count:20,start:0,profileUrn:${userInfo.urn})&queryId=voyagerFeedDashProfileUpdates.f5fee2c9e952985c98c2072e1287bacf`;

    post(url, "GET", null);
  }
  return (
    <>
        <TextField
            label="Text"
            value={text}
            onChange={(e) => setText(e.target.value)}
        />
        {/* <TextField
            label="Scheduled At"
            value={scheduledAt}
            onChange={(e) => setScheduledAt(e.target.value)}
        /> */}
        <Button onClick={() => schedulePost()}>Schedule Post</Button>
    </>
  )
}

function post(url, method, body) {
  window.postMessage({
      origin: "WEBPAGE",
      content: {
        type: "DEBUG_EXECUTE_REQUEST",
        requestData: {
          url: url,
          method: method,
          body: JSON.stringify(body),
          timeout_timestamp: new Date().getTime() + 1000 * 60 * 5
        } 
      }
  }, "*"); 
}





